import { graphql, useStaticQuery } from 'gatsby';

export const useHeader = () => {
  const header = useStaticQuery(graphql`
    query {
      contentfulHeader(title: { eq: "Header" }) {
        title
        mainNav {
          id
          title
          url
        }
        featuredTopics {
          name
          type
          slug
        }
        newsletterTitle
        newsletterPlaceholder
        learnMore {
          id
          title
          url
        }
      }
    }
  `);

  return header.contentfulHeader;
};
